export const saveCustomerInformation = (customerInformation) => {
  return (dispatch, getState, { api }) => {
    const dataToSend = {};

    // User's type depends if Vat or CVR fields are filled out when Company was selected
    if (customerInformation["type"].value === "organisation_vat") {
      const vatValue =
        customerInformation["vatNo"] && customerInformation["vatNo"].value;
      const cvrValue =
        customerInformation["associationCode"] &&
        customerInformation["associationCode"].value;

      const isAssosiation = (cvrValue && !vatValue) || (!cvrValue && !vatValue);

      // Customer type depends if either vat or cvr values are provided
      customerInformation["type"].value = isAssosiation
        ? "organisation_no_vat"
        : "organisation_vat";
    }

    let fields = {
      ...customerInformation,
      type: {
        // Default to private customer if not set
        ...customerInformation["type"],
        value: customerInformation["type"].value || "private",
      },
    };

    for (const data in fields) {
      dataToSend[data] = customerInformation[data].value;
    }

    return api
      .saveCustomerInformation({
        customerData: dataToSend,
      })
      .then(
        (data) => {
          if (data.result.success) {
            return {
              wasSuccessful: true,
            };
          }

          return {
            wasSuccessful: false,
            errors: data.result.errors.map((error) => ({
              name: error.infoFieldName,
              message: error.errorMessage,
            })),
          };
        },
        (err) => {
          return { wasSuccessful: false };
        },
      );
  };
};
